/**
 * This is a status that says all the prices of a tactic were filtered out. An example of this would be
 * if a user entered a stop on break prices: 101,100,99, and the current price is 98.5. Since 98.5 would result in
 * an automatic stop out, all prices would be filtered out, and this notification would occur.
 * {
	"messageType": "alertNotification",
	"notificationId": 1645469458808,
	"notificationDetails": {"errorType":"TACTIC_VALIDATION","notificationType":"ERROR","tacticName":"POSITION_BREAK_PRICE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "PRICE_FILTERS_TARGETS",
	"statusDetails": {"currentPrice":100.25,"targets":[87.5,85.4]},
	"date": "2022-02-21T13:51:00.392-0500",
	"timestamp": "1645469460392"
}

 * @param {*} statusDetails 
 * @returns an object that has 2 fields:
 * 1) currentPrice: the current price that caused the prices to be filtered out
 * 2) targets: list of targets that were filtered out
 */
export function priceFiltersTargetsParser(statusDetails) {
  const parsedObj = {
    currentPrice: null,
    targets: null,
  };
  if (statusDetails) {
    parsedObj.currentPrice = statusDetails.currentPrice ?? null;
    parsedObj.targets = statusDetails.targets ?? null;
  }

  return parsedObj;
}
